/**
 * Story card directive for export
 * @author Ryan Gladstone
 */

import plainTextCtrl from './PlainTextController';
import palinTextTemplate from './plainText.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      story: '=',
      singleView: '=',
      filterSet: '='
    },
    template: palinTextTemplate,
    controller: 'PlainTextController'
  };
}

export default function (ngModule) {
  ngModule.directive('plainText', directive);
  plainTextCtrl(ngModule);
}
